/* Shopify is the authority for variants, inventory, discounts and cart totals. */
(() => {
 const cfg=window.ICONS_SHOP,root=cfg.root||'/';
 const fmt=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cfg.currency}).format(cents/100);
 const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 let pending=false,refreshJob=null;
 async function api(path,data){
  const response=await fetch(root+path,{credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},...(data?{method:'POST',body:JSON.stringify(data)}:{})});
  let result;try{result=await response.json()}catch{throw new Error('Unable to contact the store. Please try again.')}
  if(!response.ok)throw new Error(result.description||result.message||'Please try again.');return result;
 }
 function error(message){const el=document.querySelector('.shop-cart-error');if(el)el.textContent=message;else alert(message);}
 function draw(cart){
  document.querySelectorAll('#cartCount').forEach(el=>el.textContent=cart.item_count);
  const body=document.getElementById('cartBody');
  if(body)body.innerHTML=cart.items.length?cart.items.map(item=>`<div class="cart-item"><div class="cart-thumb">${item.image?`<img src="${esc(item.image)}" alt="${esc(item.product_title)}">`:''}</div><div><a href="${esc(item.url)}"><b>${esc(item.product_title)}</b></a><small>${esc(item.variant_title==='Default Title'?'':item.variant_title)}</small><small>${item.quantity} × ${fmt(item.final_price)}</small><strong>${fmt(item.final_line_price)}</strong></div><button type="button" class="close" data-remove-key="${esc(item.key)}" aria-label="Remove ${esc(item.product_title)}">×</button></div>`).join(''):`<p>Your bag is empty.</p><a class="btn" href="${root}collections/all">Explore the cases</a>`;
  const total=document.getElementById('subtotal');if(total)total.textContent=fmt(cart.total_price);
  const savings=document.getElementById('cartSavings');if(savings)savings.textContent=cart.total_discount?`You save ${fmt(cart.total_discount)}`:'';
  document.querySelectorAll('.checkout').forEach(b=>b.disabled=cart.item_count===0);
  document.querySelectorAll('[data-clear-cart]').forEach(b=>{b.hidden=cart.item_count===0;});
  const status=document.querySelector('.shop-shipping-status'),progress=document.querySelector('.shop-shipping-progress');
  if(status){
   const au=cfg.country==='AU'&&cfg.currency==='AUD';
   status.textContent=au?(cart.total_price>=10000?'You qualify for free Australian shipping.':`Add ${fmt(10000-cart.total_price).replace(/\.00$/, '')} for free Australian shipping.`):'Worldwide delivery. Shipping calculated at checkout.';
   if(progress){progress.hidden=!au;progress.value=Math.min(10000,cart.total_price)}
  }
  const shipping=document.querySelector('.au-shipping-rate');if(shipping)shipping.textContent=cfg.country==='AU'?'Australia-wide delivery: '+(cart.total_price>=10000&&cfg.currency==='AUD'?'FREE':'A$9.99'):'International delivery calculated at checkout.';
 }
 async function refresh(){if(refreshJob)return refreshJob;refreshJob=api('cart.js').then(draw).catch(e=>error(e.message)).finally(()=>refreshJob=null);return refreshJob;}
 function busy(on){
  document.querySelectorAll('#addBundleBtn,[data-print-add],[data-print-buy]').forEach(b=>{
   if(on){b.dataset.wasDisabled=String(b.disabled);b.dataset.beforeAdd=b.textContent;b.disabled=true;b.setAttribute('aria-busy','true');b.textContent='Adding…';}
   else{b.disabled=b.dataset.wasDisabled==='true';b.textContent=b.dataset.beforeAdd||b.textContent;b.removeAttribute('aria-busy');}
  });
 }
 async function add(items,buy=false){
  if(pending)return;pending=true;error('');busy(true);
  try{await api('cart/add.js',{items});await refresh();if(buy)location.assign(root+'checkout');else window.openCart?.();}
  catch(e){window.openCart?.();error(e.message)}finally{pending=false;busy(false);updateAvailability()}
 }
 function find(range,name){const product=cfg.products[range];return product?.variants?.find(v=>v.option1===name||v.title===name)}
 window.IconsCommerce={refresh,
  async clear(button){
   if(pending)return;
   pending=true;button.disabled=true;button.setAttribute('aria-busy','true');error('');
   try{
    if(refreshJob)await refreshJob;
    draw(await api('cart/clear.js',{}));
    document.querySelectorAll('.shop-code-status').forEach(el=>el.textContent='');
    if(button.hasAttribute('data-cart-page')){location.reload();return;}
    document.querySelector('#cartBody a')?.focus();
   }catch(e){error(e.message)}finally{pending=false;button.disabled=false;button.removeAttribute('aria-busy');}
  },
  async addColours(range,names){
   const variants=names.map(n=>find(range,n));
   if(variants.some(v=>!v||!v.available)){window.openCart?.();error('One of these colours is unavailable. Please choose another colour.');return;}
   const quantities=new Map();variants.forEach(v=>quantities.set(v.id,(quantities.get(v.id)||0)+1));
   const setId=globalThis.crypto?.randomUUID?.()||String(Date.now());
   return add([...quantities].map(([id,quantity])=>({id,quantity,...(range==='original'&&cfg.bundles?{properties:{_icons_set:setId,_icons_set_size:String(names.length)}}:{})})));
  },
  async addPrint(name,buy=false){const v=cfg.products[name]?.variants?.[0];if(!v?.available){window.openCart?.();error('This print is sold out.');return;}return add([{id:v.id,quantity:1}],buy);},
  async remove(key){if(pending)return;pending=true;try{draw(await api('cart/change.js',{id:key,quantity:0}));error('')}catch(e){error(e.message)}finally{pending=false}}
 };
 document.addEventListener('click',e=>{const clear=e.target.closest('[data-clear-cart]');if(clear)window.IconsCommerce.clear(clear);const rm=e.target.closest('[data-remove-key]');if(rm)window.IconsCommerce.remove(rm.dataset.removeKey);const buy=e.target.closest('[data-print-buy]');if(buy)window.IconsCommerce.addPrint(buy.dataset.printBuy,true);});
 document.querySelectorAll('.shop-discount').forEach(form=>form.addEventListener('submit',async e=>{
  e.preventDefault();if(!form.reportValidity())return;const status=form.querySelector('[role="status"]'),button=form.querySelector('button');button.disabled=true;status.textContent='Checking code…';
  try{const result=await api('cart/update.js',{discount:form.elements.discount.value.trim()});draw(result);const codes=result.discount_codes||[];status.textContent=codes.some(c=>c.applicable&&String(c.code).toLowerCase()===form.elements.discount.value.trim().toLowerCase())?'Discount applied. See your savings above.':'This code is not applicable to the items in your bag.';}
  catch(e){status.textContent=e.message}finally{button.disabled=false}
 }));
 function updateAvailability(){
  const selection=window.iconsSelections?.();if(!selection)return;
  const p=cfg.products[selection.range],variants=selection.names.map(n=>find(selection.range,n));
  const b=document.getElementById('addBundleBtn');if(b){b.disabled=variants.some(v=>!v?.available);if(b.disabled)b.textContent=p?.id?'Selected colour unavailable':'Collection being prepared';}
  document.querySelectorAll('.swatch').forEach(b=>{
   const v=find(selection.range,b.dataset.name),available=!!v?.available;
   b.classList.toggle('is-unavailable',!available);b.disabled=!available;
   b.title=b.dataset.name+(available?' · In stock':' · Sold out');
   b.setAttribute('aria-label',b.title);
   let label=b.querySelector('.icons-stock-label');
   if(!label){label=document.createElement('span');label.className='icons-stock-label';b.append(label);}
   label.textContent=b.dataset.name;
   let status=b.querySelector('.icons-sold-label');
   if(!status){status=document.createElement('span');status.className='icons-sold-label';b.append(status);}
   status.textContent=available?'':'Sold out';status.hidden=available;
  });
 }
 document.addEventListener('icons:colour',updateAvailability);
 document.querySelector('.order-form')?.addEventListener('submit',e=>{const fields=[...e.target.querySelectorAll('.wholesale-quantity')],count=fields.reduce((n,f)=>n+Number(f.value||0),0),stand=e.target.querySelector('.stands input:checked');if((count>0&&count<100)||(!count&&!stand)){e.preventDefault();const field=fields[0];if(field){field.setCustomValidity('Choose at least 100 cases, or select a display stand for a display-only enquiry.');field.reportValidity();}}});
 document.querySelectorAll('.wholesale-quantity').forEach(f=>f.addEventListener('input',()=>document.querySelectorAll('.wholesale-quantity').forEach(x=>x.setCustomValidity(''))));
 document.querySelectorAll('[data-print-add],[data-print-buy]').forEach(b=>{const name=b.dataset.printAdd||b.dataset.printBuy;const v=cfg.products[name]?.variants?.[0];b.disabled=!v?.available;if(!v?.available)b.textContent='Sold out';});
 // Keep the colour picker and its images, but read live variant prices.
 if(typeof renderSelection==='function'){
  const originalRender=renderSelection;
  renderSelection=function(){
   originalRender();const selection=window.iconsSelections?.();if(!selection)return;
   const variants=selection.names.map(n=>find(selection.range,n));
   if(variants.length&&variants.every(Boolean)&&!(cfg.bundles&&selection.range==='original'&&cfg.currency==='AUD')){
    const cents=variants.reduce((s,v)=>s+v.price,0);
    const total=document.getElementById('bundleTotal');if(total)total.textContent=fmt(cents);const unit=document.getElementById('pdpPrice');if(unit)unit.textContent=fmt(variants[0].price)+' each';
    const button=document.getElementById('addBundleBtn');if(button)button.textContent=`Add ${variants.length===1?'to bag':variants.length+' cases to bag'} · ${fmt(cents)}`;
   }
   const unit=document.getElementById('pdpPrice');if(unit&&variants[0])unit.textContent=fmt(variants[0].price)+' each';
   updateAvailability();
  };
  if(!cfg.bundles||cfg.currency!=='AUD')document.querySelectorAll('.bundle-save,.best-label,.bundle-total-saving').forEach(el=>el.hidden=true);
  document.querySelectorAll('.bundle-card').forEach(b=>{const range=document.body.dataset.caseRange||'original';const product=cfg.products[range];if(product?.variants?.length){const n=Number(b.dataset.count);const price=b.querySelector('.bundle-price');if(price)price.textContent=fmt(cfg.bundles&&range==='original'&&cfg.currency==='AUD'?({1:2000,2:3500,3:4500,4:6000}[n]):product.variants[0].price*n)}});
  renderSelection();
 }
 // Collection cards use Shopify prices in the selected currency.
 document.querySelectorAll('.range-card').forEach(card=>{
  const range=['kids','original','xl','sports'].find(r=>card.classList.contains('range-'+r));
  const price=cfg.products[range]?.variants?.[0]?.price,el=card.querySelector('.range-card-head strong');
  if(el&&Number.isFinite(price))el.textContent=fmt(price)+' each';
 });
 document.querySelectorAll('.print-card').forEach(card=>{
  const name=card.querySelector('[data-print-add]')?.dataset.printAdd;
  const price=cfg.products[name]?.variants?.[0]?.price,el=card.querySelector('.print-price');
  if(el&&Number.isFinite(price))el.textContent=fmt(price)+' each';
 });
 // Native product forms retain a no-JavaScript fallback.
 const native=document.querySelector('.icons-native-product');
 if(native){const select=native.querySelector('[name="id"]');select?.addEventListener('change',()=>{const v=cfg.current?.variants.find(v=>String(v.id)===select.value);if(!v)return;native.querySelector('[data-native-price]').textContent=fmt(v.price);native.querySelector('[name="add"]').disabled=!v.available;const img=document.querySelector('[data-native-image]');if(img&&v.featured_image?.src)img.src=v.featured_image.src;const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url)});}
 refresh();
})();
/* Mix & Match display for all four case sizes. */
(() => {
  const shop = window.ICONS_SHOP;
  const uk = shop?.currency === 'GBP' && shop.country === 'GB' && shop.ukBundles;
  if (!(shop?.bundles && shop.currency === 'AUD') && !uk) return;
  if (
      typeof renderSelection !== 'function') return;

  const format = cents => new Intl.NumberFormat(uk ? 'en-GB' : 'en-AU', {
    style: 'currency', currency: shop.currency
  }).format(cents / 100);

  function updateBundleOffer() {
    const selection = window.iconsSelections?.();
    if (!selection ||
        !['original','kids','xl','sports'].includes(selection.range)) return;

    const kids = selection.range === 'kids';
    const totals = uk ? (kids ? [0,699,1200,1400,1900] : [0,999,1800,2300,3000]) : (kids ? [0,1500,2500,3000,4000] : [0,2000,3500,4500,6000]);
    const unit = totals[1];
    if (uk && !shop.products[selection.range]?.variants?.every(v => v.price === unit)) return;
    document.querySelectorAll('.bundle-card .best-label').forEach(el=>el.hidden=false);
    const count = selection.names.length;
    if (!totals[count]) return;

    document.querySelectorAll('.bundle-card').forEach(card => {
      const n = Number(card.dataset.count);
      if (!totals[n]) return;

      const price = card.querySelector('.bundle-price');
      if (price) price.textContent = format(totals[n]);
      card.dataset.price = String(totals[n] / 100);

      let saving = card.querySelector('.bundle-save');
      if (!saving) {
        saving = document.createElement('small');
        saving.className = 'bundle-save';
        card.append(saving);
      }
      saving.hidden = n === 1;
      saving.textContent = n > 1
        ? 'Save ' + format(n * unit - totals[n]) : '';
      saving.style.color = '#187333';
      saving.style.fontWeight = '800';
    });

    const total = document.getElementById('bundleTotal');
    if (total) {
      total.textContent = format(totals[count]);
      if (count > 1) {
        const saving = document.createElement('strong');
        saving.className = 'bundle-total-saving';
        saving.style.color = '#187333';
        saving.textContent =
          'Save ' + format(count * unit - totals[count]);
        total.append(' · ', saving);
      }
    }

    const price = document.getElementById('pdpPrice');
    if (price) price.textContent = format(unit) + ' each';

    const button = document.getElementById('addBundleBtn');
    if (button && !button.disabled) {
      button.textContent =
        'Add ' + (count === 1 ? 'to bag' : count + ' cases to bag') +
        ' · ' + format(totals[count]);
    }

    const sticky = document.getElementById('stickyPrice');
    if (sticky) {
      sticky.textContent =
        count + (count === 1 ? ' case' : ' cases') +
        ' · ' + format(totals[count]);
    }
  }

  const previousRender = renderSelection;
  renderSelection = function() {
    previousRender();
    updateBundleOffer();
  };

  updateBundleOffer();
})();
(()=>{const s=window.ICONS_SHOP;if(!s)return;const f=c=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:s.currency}).format(c/100);const original=s.products.original?.variants?.[0]?.price;const uk=s.currency==='GBP'&&s.country==='GB'&&s.ukBundles&&s.products.original?.variants?.every(v=>v.price===999);const totals=s.currency==='AUD'&&s.bundles?[0,2000,3500,4500,6000]:uk?[0,999,1800,2300,3000]:null;
document.querySelectorAll('.offer-card[data-bundle]').forEach(card=>{const n=Number(card.dataset.bundle);if(!Number.isFinite(original))return;const price=card.querySelector(':scope>b');if(price)price.textContent=f(totals?totals[n]:original*n);const saving=card.querySelector('.offer-saving');if(saving){saving.textContent=totals&&n>1?'Save '+f(original*n-totals[n]):'Choose any colour';}if(!totals){const badge=card.querySelector('.offer-badge');if(badge)badge.textContent='Mix & Match';}});
const disclaimer=document.querySelector('.offer-disclaimer');if(disclaimer)disclaimer.textContent='Original range · All prices in '+s.currency;
if(s.currency!=='AUD'){const prices=['original','kids','xl','sports'].flatMap(k=>s.products[k]?.variants?.map(v=>v.price)||[]);if(prices.length)document.querySelectorAll('.hero-offer').forEach(el=>el.textContent='From '+f(Math.min(...prices))+'.');}
})();
